import { render, staticRenderFns } from "./MissedCallReport.vue?vue&type=template&id=12794692"
import script from "./MissedCallReport.vue?vue&type=script&lang=js"
export * from "./MissedCallReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports